export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL'
export const USER_REGISTER_UNSET = 'USER_REGISTER_UNSET'

export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_LOGIN_UNSET = 'USER_LOGIN_UNSET'

export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST'
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS'
export const USER_UPDATE_FAIL    = 'USER_UPDATE_FAIL'
export const USER_UPDATE_UNSET = 'USER_UPDATE_UNSET'

export const USER_REMOVE_REQUEST = 'USER_REMOVE_REQUEST'
export const USER_REMOVE_SUCCESS = 'USER_REMOVE_SUCCESS'
export const USER_REMOVE_FAIL    = 'USER_REMOVE_FAIL'
export const USER_REMOVE_UNSET = 'USER_REMOVE_UNSET'

export const USER_ALL_REQUEST = 'USER_ALL_REQUEST'
export const USER_ALL_SUCCESS = 'USER_ALL_SUCCESS'
export const USER_ALL_FAIL    = 'USER_ALL_FAIL'

export const USER_ACTIVATE_REQUEST = 'USER_ACTIVATE_REQUEST'
export const USER_ACTIVATE_SUCCESS = 'USER_ACTIVATE_SUCCESS'
export const USER_ACTIVATE_FAIL    = 'USER_ACTIVATE_FAIL'

export const USER_PROMOTE_REQUEST = 'USER_PROMOTE_REQUEST'
export const USER_PROMOTE_SUCCESS = 'USER_PROMOTE_SUCCESS'
export const USER_PROMOTE_FAIL    = 'USER_PROMOTE_FAIL'

export const USER_PUBLIC_ACCOUNT_REQUEST = 'USER_PUBLIC_ACCOUNT_REQUEST'
export const USER_PUBLIC_ACCOUNT_SUCCESS = 'USER_PUBLIC_ACCOUNT_SUCCESS'
export const USER_PUBLIC_ACCOUNT_FAIL    = 'USER_PUBLIC_ACCOUNT_FAIL'

export const USER_LINK_MEMBER_REQUEST = 'USER_LINK_MEMBER_REQUEST'
export const USER_LINK_MEMBER_SUCCESS = 'USER_LINK_MEMBER_SUCCESS'
export const USER_LINK_MEMBER_FAIL    = 'USER_LINK_MEMBER_FAIL'
export const USER_LINK_MEMBER_UNSET = 'USER_LINK_MEMBER_UNSET'

export const USER_RESET_PASS_LINK_REQUEST = 'USER_RESET_PASS_LINK_REQUEST'
export const USER_RESET_PASS_LINK_SUCCESS = 'USER_RESET_PASS_LINK_SUCCESS'
export const USER_RESET_PASS_LINK_FAIL    = 'USER_RESET_PASS_LINK_FAIL'

export const USER_RESET_PASSWORD_REQUEST = 'USER_RESET_PASSWORD_REQUEST'
export const USER_RESET_PASSWORD_SUCCESS = 'USER_RESET_PASSWORD_SUCCESS'
export const USER_RESET_PASSWORD_FAIL    = 'USER_RESET_PASSWORD_FAIL'
